import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import OneStat from '@components/lpc/ActivityReport/Stats/OneStat/OneStat';

import css from './Stats.module.scss';

const Stats = () => {
    const { t } = useTranslateLpc('lpc-report');

    const stats: { key: string | any; value: string | any }[] = Array.from({ length: 5 }, (_, index) => index + 1).map(
        (index) => {
            return { key: t(`stats.${index - 1}.key`), value: t(`stats.${index - 1}.value`) };
        },
    );
    return (
        <>
            <div className={css.stats}>
                <div className={css.title}>
                    <h1>{t('subtitle')}</h1>
                </div>
                <div className={css.stats__list}>
                    {stats?.map((stat, index) => (
                        <OneStat key={stat.key} stat={stat} color={index % 2 === 0 ? '#E22B76' : '#232e69'} />
                    ))}
                </div>
            </div>
        </>
    );
};

export default Stats;
